import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
	Button,
	Form,
	FormGroup,
	Row,
	Col,
	Input,
	FormFeedback,
	Label,
} from "reactstrap";
import { FloppyDisk, SignOut } from "@phosphor-icons/react";
import loginQuotesService from "services/LoginQuotesService";

const CreateEditLoginQuoteModal = ({ show, onCloseClick, data }) => {
	const id = data?.id;

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			quote: data?.quote || "",
			author: data?.author || "",
		},

		validationSchema: Yup.object({
			quote: Yup.string().required("Por favor, informe a frase."),
			author: Yup.string().required(
				"Por favor, informe o nome do autor da frase.",
			),
		}),

		onSubmit: async (values) => {
			try {
				if (id) {
					await loginQuotesService.update(id, values);
				} else {
					await loginQuotesService.create(values);
				}
				onCloseClick();
			} catch (error) {
				console.log(error);
			}
		},
	});

	return (
		<>
			<Modal
				size="sm"
				isOpen={show}
				toggle={onCloseClick}
				centered={true}
				style={{ minWidth: 800 }}
			>
				<div className="modal-content">
					<ModalBody className="px-4 py-3 text-center">
						<Col md="12">
							<Form
								className="needs-validation"
								onSubmit={(e) => {
									e.preventDefault();
									validation.handleSubmit();
								}}
							>
								<h4 className="text-center my-4">
									{id ? "Editar Frase" : "Nova Frase"}
								</h4>

								{/* Frase */}
								<Row>
									<Col md="12">
										<FormGroup className="mb-3">
											<Label htmlFor="quote">
												Frase{" "}
												<span style={{ color: "red" }}>
													*
												</span>
											</Label>
											<Input
												name="quote"
												type="textarea"
												placeholder="Digite a frase"
												onChange={
													validation.handleChange
												}
												onBlur={validation.handleBlur}
												value={
													validation.values.quote ||
													""
												}
												invalid={
													validation.touched.quote &&
													Boolean(
														validation.errors.quote,
													)
												}
											/>
											{validation.touched.quote &&
											validation.errors.quote ? (
												<FormFeedback type="invalid">
													{validation.errors.quote}
												</FormFeedback>
											) : null}
										</FormGroup>
									</Col>
								</Row>
								{/* Autor */}
								<Row>
									<Col md="12">
										<FormGroup className="mb-3">
											<Label htmlFor="author">
												Autor{" "}
												<span style={{ color: "red" }}>
													*
												</span>
											</Label>
											<Input
												name="author"
												type="textarea"
												placeholder="Digite o nome do autor"
												onChange={
													validation.handleChange
												}
												onBlur={validation.handleBlur}
												value={
													validation.values.author ||
													""
												}
												invalid={
													validation.touched.author &&
													Boolean(
														validation.errors
															.author,
													)
												}
											/>
											{validation.touched.author &&
											validation.errors.author ? (
												<FormFeedback type="invalid">
													{validation.errors.author}
												</FormFeedback>
											) : null}
										</FormGroup>
									</Col>
								</Row>

								{/* Botões de Submissão e Fechamento */}
								<Row className="py-1">
									<div className="hstack gap-2 justify-content-center mb-0">
										<Button
											type="submit"
											disabled={validation.isSubmitting}
											style={{
												background: "none",
												padding: 10,
												cursor: "pointer",
												color: "black",
												marginLeft: 10,
												width: 150,
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												gap: 2,
											}}
										>
											{validation.isSubmitting ? (
												<span
													className="spinner-border spinner-border-sm mr-1"
													style={{ marginRight: 10 }}
												></span>
											) : null}
											<FloppyDisk size={16} /> Salvar
										</Button>
										<Button
											type="button"
											onClick={onCloseClick}
											style={{
												background: "none",
												padding: 10,
												cursor: "pointer",
												color: "black",
												marginLeft: 10,
												width: 150,
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												gap: 2,
											}}
										>
											<SignOut size={16} /> Fechar
										</Button>
									</div>
								</Row>
							</Form>
						</Col>
					</ModalBody>
				</div>
			</Modal>
		</>
	);
};

CreateEditLoginQuoteModal.propTypes = {
	show: PropTypes.bool,
	onCloseClick: PropTypes.func,
	data: PropTypes.any,
	changePrazoItem: PropTypes.func,
};

export default CreateEditLoginQuoteModal;
